import React, { useState, useRef, useEffect } from "react";
import { decodeHtml } from "../../../../assests/extention/commonfunction";
import DOMPurify from "dompurify";

export default function CustomReactQuillDescription({ value, displyreadorless = true }) {
  const [expanded, setExpanded] = useState(false);
  const [shouldShowToggle, setShouldShowToggle] = useState(false);
  const contentRef = useRef(null);

  const decodedValue = DOMPurify.sanitize(decodeHtml(value || ""));

  useEffect(() => {
    if (!contentRef.current) return;

    const el = contentRef.current;

    const checkHeight = () => {
      if (el) {
        // Since .truncate limits height to 48px, any scrollHeight > 50 means there is hidden content.
        setShouldShowToggle(el.scrollHeight > 50);
      }
    };

    // Check immediately
    checkHeight();

    // Check after short delays to ensure styles/fonts are fully loaded
    const t1 = setTimeout(checkHeight, 100);
    const t2 = setTimeout(checkHeight, 500);
    const t3 = setTimeout(checkHeight, 1000);

    // Watch for dimension changes (e.g. window resize or layout shifts)
    const observer = new ResizeObserver(() => {
      checkHeight();
    });
    observer.observe(el);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      observer.disconnect();
    };
  }, [decodedValue]);

  return (
    <div className="description-sec-p">
      <style>
        {`
          .custom-html p, 
          .custom-html h1, 
          .custom-html h2, 
          .custom-html h3, 
          .custom-html h4, 
          .custom-html h5, 
          .custom-html h6 {
            color: #000000ff !important;
            margin: 0 0 8px 0;
          }

          .custom-html ul, 
          .custom-html ol {
            margin: 0 !important;
            padding-left: 20px !important;
            display: block !important;
          }

          .custom-html li {
            margin-bottom: 4px;
            display: list-item !important;
            list-style-position: outside !important;
          }

          .custom-html ul li {
            list-style-type: disc !important;
          }

          .custom-html ol li {
            list-style-type: decimal !important;
          }

          /* Truncate with max-height and ensure bullets are visible */
          .custom-html.truncate {
            max-height: 48px;
            overflow: hidden;
            position: relative;
          }

          .custom-html.truncate::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 20px;
            background: linear-gradient(transparent, white);
            pointer-events: none;
          }

          .view-toggle {
            color: #007bff;
            cursor: pointer;
            font-weight: 500;
            margin-top: 5px;
            display: inline-block;
          }

          /* Force show bullets in all states */
          .custom-html * {
            box-sizing: border-box;
          }


          .custom-html p{
          margin-left:0 !important;
          }
        `}
      </style>

      {value && (
        <>
          <div
            ref={contentRef}
            className={`custom-html ${!expanded ? "truncate" : ""}`}
            dangerouslySetInnerHTML={{ __html: decodedValue }}
          />
          {
            displyreadorless && (
              <>
                {shouldShowToggle && (
                  <span
                    className="view-toggle"
                    onClick={() => setExpanded((prev) => !prev)}
                  >
                    {expanded ? "read less" : "read more"}
                  </span>
                )}
              </>
            )
          }
        </>
      )}
    </div>
  );
}